import type { TrackingContext } from '@mentimeter/http-clients';
import { ViewOnlyAuthButtons } from 'features/core/editor/Header/view-only/ViewOnlyAuthButtons';
import { Box } from '@mentimeter/ragnar-ui/box';
import { FOOTER_ACTIONS_HEIGHT_MOBILE } from '@mentimeter/editor-properties-pane';
import { ViewOnlyCommentDrawer } from './ViewOnlyCommentDrawer';

export const ViewOnlyFooter = ({
  isVisitor,
  buttonSize,
  seriesId,
  trackingContext,
  isCommentDrawerOpen,
  isShared,
  currentPlan,
  roleInWorkspace,
}: {
  isVisitor: boolean;
  buttonSize: 'default' | 'compact';
  seriesId: string;
  trackingContext: TrackingContext;
  isCommentDrawerOpen: boolean;
  isShared: boolean;
  currentPlan: string;
  roleInWorkspace: string;
}) => {
  if (isVisitor)
    return (
      <Box
        bg="bg"
        alignItems="center"
        flexDirection="row"
        justifyContent="center"
        height={FOOTER_ACTIONS_HEIGHT_MOBILE}
        width="100%"
      >
        <ViewOnlyAuthButtons
          buttonSize={buttonSize}
          seriesId={seriesId}
          trackingContext={trackingContext}
        />
      </Box>
    );

  return (
    <ViewOnlyCommentDrawer
      open={isCommentDrawerOpen}
      isShared={isShared}
      currentPlan={currentPlan}
      roleInWorkspace={roleInWorkspace}
      trackingContext={trackingContext}
    />
  );
};
